import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { CONTACT_EMAIL } from "@/lib/site";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ children, testid, dark = false }) => (
  <div className="flex items-center gap-4" data-testid={testid}>
    <span className="h-px w-10 bg-bz-amber" />
    <span className={`bz-label ${dark ? "text-white/50" : ""}`}>{children}</span>
  </div>
);

export const EmailButton = ({ label = "Être informé du lancement", testid = "newsletter-email-button", dark = false }) => (
  <a
    href={`mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent("Inscription future à la lettre BENZENATI")}`}
    data-testid={testid}
    className={
      dark
        ? "inline-flex items-center justify-center bg-bz-amber px-8 py-4 text-xs uppercase tracking-[0.18em] text-bz-navy transition-colors duration-300 hover:bg-bz-ivory"
        : "inline-flex items-center justify-center bg-bz-navy px-8 py-4 text-xs uppercase tracking-[0.18em] text-bz-ivory transition-colors duration-300 hover:bg-bz-petrol"
    }
  >
    {label}
  </a>
);

export const PrimaryLink = ({ to, children, testid }) => (
  <Link
    to={to}
    data-testid={testid}
    className="inline-flex items-center justify-center bg-bz-navy px-8 py-4 text-xs uppercase tracking-[0.18em] text-bz-ivory transition-colors duration-300 hover:bg-bz-petrol"
  >
    {children}
  </Link>
);

export const GhostLink = ({ to, children, testid }) => (
  <Link
    to={to}
    data-testid={testid}
    className="inline-flex items-center justify-center border border-bz-navy px-8 py-4 text-xs uppercase tracking-[0.18em] text-bz-navy transition-colors duration-300 hover:bg-bz-navy hover:text-bz-ivory"
  >
    {children}
  </Link>
);

export const PageHero = ({ label, title, intro, testid = "page-hero" }) => (
  <section className="border-b border-bz-line" data-testid={testid}>
    <div className="mx-auto max-w-7xl px-6 py-20 lg:px-10 lg:py-28">
      <Reveal>
        {label && <SectionLabel>{label}</SectionLabel>}
        <h1 className="mt-8 max-w-4xl font-serif text-4xl leading-[1.05] tracking-tight text-bz-navy sm:text-5xl lg:text-6xl">
          {title}
        </h1>
        {intro && (
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-bz-slate lg:text-lg">{intro}</p>
        )}
      </Reveal>
    </div>
  </section>
);
